export const PAGE_LOAD_WAITING = 750;
